
import { Player } from './Player';
import { BaseSpriteInterface } from './SpriteInterfaces';
import BaseLevelScene from 'src/app/Scenes/BaseLevelScene';

export type consequence = "resetsLevel" | "hurtsYou";

export interface HazardDataInterface extends BaseSpriteInterface{
  width: number;
  height: number;
  consequence: consequence;
}

export class Hazard extends Phaser.Physics.Matter.Sprite{
  public playerOffsetX: number = 0;
  public playerOffsetY: number = 0;
  consequence: consequence

  constructor(data: HazardDataInterface, playerScale=1, playerOffsetX=0, playerOffsetY=0) {
    let { scene, x, y, width, height, texture, consequence } = data;
    super(scene.matter.world, x, y, texture);

    this.scene = scene as BaseLevelScene;
    this.playerOffsetX = playerOffsetX;
    this.playerOffsetY = playerOffsetY;
    this.consequence = consequence;
    
    // Create sensors for contacting hazard
    const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var hazardSensor = Bodies.rectangle(x, y, width, height, {
      isSensor: true,
      label: 'hazardSensor',
    });

    this.setExistingBody(hazardSensor);

    // add the portal the scene
    this.scene.add.existing(this);
    this.setStatic(true);
    this.setDepth(2);
    this.setVisible(false);
  }

  applyConsequence(player: Player) {
    console.log("Hazard interacted with consequence is: ", this.consequence);
    if(this.consequence === "resetsLevel"){
      (player.scene as BaseLevelScene).resetLevel();
      if(player.health > 0){
        player.sound.play();
        player.health -= 1;
        player.flash();
      }
    }
    else if(this.consequence === "hurtsYou"){
      if(player.health > 0){
        player.sound.play();
        player.health -= 1;
        player.flash();
      }
    }
  }
}
